module.exports = __webpack_public_path__ + "img/di.e04bedfc.png";